export default "__VITE_ASSET__FCydnzdj__"